import moment from 'moment-timezone';

(() => {
  class UserNotesController {
    constructor($scope, toastr, Users, Notifications, $rootScope) {
      'ngInject';

      Object.assign(this, {
        $scope,
        toastr,
        Users,
        Notifications,
        $rootScope,
        patientId: null,
        beforeCursor: null,
        afterCursor: null,
        textRequired: true,
        showForm: false,
        showList: false,
        showNoPreviousNotes: false,
        selectedFilter: "PMH",
        selectedCat: "PMH",
        note: null,
        user_note_id: null,
        timezone: $rootScope.timezones[0].timezone,
        categories: [{
          type: "PMH",
          description: "PMH"
        }, {
          type: "patient support",
          description: "Patient Support"
        }, {
          type: "general",
          description: "General"
        }, {
          type: "pharmacy",
          description: "Pharmacy"
        }, {
          type: "annual_gift",
          description: "Annual Member Gift"
        }],
        categoriesFilter: [{
          type: "PMH",
          description: "PMH"
        }, {
          type: "patient support",
          description: "Patient Support"
        }, {
          type: "general",
          description: "General"
        }, {
          type: "pharmacy",
          description: "Pharmacy"
        }, {
          type: "annual_gift",
          description: "Annual Member Gift"
        }, {
          type: "all",
          description: "All"
        }]
      }); // Search mode

      this.showForm = false;
      this.showList = true;
    }

    $onInit() {
      this.patientId = this.user.id;
      this.search(this.selectedFilter);
    }

    timezoneChanged() {
      this.search(this.selectedFilter);
    }

    formatDate(iso_date) {
      if (!iso_date) return null;
      const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    }

    getDescCategory(type) {
      var typeDesc = "";
      this.categories.forEach((category, j) => {
        if (category.type === type) {
          typeDesc = category.description;
        }
      });
      return typeDesc;
    }

    getFullName(id) {
      return new Promise((resolve, reject) => {
        this.Users.getOne(id).then(data => {
          resolve({
            id: id,
            fullname: data.data.firstname + " " + data.data.lastname
          });
        }).catch(err => {
          console.log(err);
          resolve({
            id: id,
            fullname: ""
          });
        });
      });
    }

    filterClick() {
      // if (this.showForm) {
      this.showForm = false;
      this.showList = true;
      this.search(this.selectedFilter); // }
    }

    search(filter) {
      this.loadingPatientNotes = true;
      this.patientNotes = [];
      this.showNoPreviousNotes = false;
      var pagination = {
        limit: 999999
      };
      this.Users.getPatientNotes(this.patientId, pagination).then(data => {
        var allPatientNotes = data.data.data; //console.log('Patient Notes', allPatientNotes);

        if (!allPatientNotes || allPatientNotes.length === 0) {
          this.showForm = false;
          this.showList = false; //this.addNote();

          this.showNoPreviousNotes = true;
        } else {
          allPatientNotes.sort(function (a, b) {
            var timestampA = !a.modified ? a.created : a.modified;
            var timestampB = !b.modified ? b.created : b.modified;
            return timestampB - timestampA;
          });
          allPatientNotes.forEach((patientNote, j) => {
            if (filter === "all" || filter === patientNote.type) {
              var timestamp = !patientNote.modified ? patientNote.created : patientNote.modified;
              patientNote.date = new Date(timestamp * 1000);
              var title = !patientNote.doctor.title ? "" : patientNote.doctor.title + " ";
              patientNote.fullname = title + patientNote.doctor.firstname + " " + patientNote.doctor.lastname;
              patientNote.typeDesc = this.getDescCategory(patientNote.type);
              this.patientNotes.push(patientNote);
            }
          });

          if (this.patientNotes.length === 0) {
            this.showForm = false;
            this.showList = false; //this.addNote();

            this.showNoPreviousNotes = true;
          }
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        this.loadingPatientNotes = false;
      });
    }

    addNote() {
      this.showList = false;
      this.textRequired = false;
      this.user_note_id = null;
      this.note = null;
      this.selectedCat = "PMH";
      this.textRequired = true;
    }

    editNote(patientNote) {
      this.user_note_id = patientNote.user_note_id;
      this.note = patientNote.text;
      this.selectedCat = patientNote.type;
    }

    save() {
      this.saving = true;
      var data = {
        text: this.note,
        type: this.selectedCat
      };

      if (this.user_note_id) {
        this.Users.updatePatientNote(this.patientId, this.user_note_id, data).then(() => {
          this.toastr.success(this.Notifications.patient.notes.success);
        }).catch(err => {
          if (err.status === 403) {
            this.toastr.error(this.Notifications.orders.locked);
          } else {
            this.toastr.error(this.Notifications.patient.notes.error);
          }
        }).finally(() => {
          this.saving = false;
          this.showForm = false;
          this.showList = true;
          this.search(this.selectedFilter);
        });
      } else {
        this.Users.createPatientNote(this.patientId, data).then(() => {
          this.toastr.success(this.Notifications.patient.notes.success);
        }).catch(err => {
          if (err.status === 403) {
            this.toastr.error(this.Notifications.orders.locked);
          } else {
            this.toastr.error(this.Notifications.patient.notes.error);
          }
        }).finally(() => {
          this.saving = false;
          this.showForm = false;
          this.showList = true;
          this.search(this.selectedFilter);
        });
      }
    }

  }

  UserNotesController.$inject = ["$scope", "toastr", "Users", "Notifications", "$rootScope"];
  angular.module('pims').component('userNotes', {
    templateUrl: 'app/views/users/detail/tabs/patient-profile-notes/user-notes.tab.html',
    controller: UserNotesController,
    controllerAs: 'patProNotes',
    bindings: {
      user: '<'
    }
  });
})();
